export default "__VITE_ASSET__4edaa224__"